import tyreStack from "../images/tyres.png"
import '../App.css';

function AboutThree() {
    return (
<div className="hero justify-start bg-white text-white font-general italic">
        <div className="flex flex-row items-center">
        <div className="flex flex-col gap-10 ml-10 p-20 font-bold w-full md:w-3/4">
          <p className="text-xl text-zinc-800 text-center md:text-left">
          Our commitment to excellence is reflected in our 5-star reviews, where customers consistently praise our team's expertise, rapid response times, and exceptional service quality.
          </p>
          </div> 
        <div className="hidden md:flex md:flex-col md:p-20 md:justify-center items-center md:font-bold md:w-1/4">
            <img
            src={tyreStack}
            width={200}
            className="max-w-sm pr-10" 
            alt="tyre stack"
            />
          </div> 
        </div>
      </div>
  );
}

export default AboutThree;
